// extracted by mini-css-extract-plugin
module.exports = {"price__container":"Price_price__container__Hmqw4","price":"Price_price__4O0CY","price--responsive":"Price_price--responsive__LP3cg"};